import { addModal } from "../../../../../app.logic";
import lodash from "lodash";
import { modalStyleIFrame } from "../../../../../utils/constant";

import {
    createManageActive,
    createManageArchive,
    createManageDelete, createManageExportCsv, createManageExtraCreate,
    createManageSelect,
    createPage, createRowActionEdit, createRowActionView
} from "../../../../../utils/page";
import { has } from "../../../../../utils/menu-context";
import { defineAsyncComponent } from "vue";

import {
    onClickActiveAll,
    onClickArchiveAll,
    onClickCreate,
    onClickDeleteAll,
    onClickEdit,
    onClickView
} from "../../../../../utils/form";

import { createColumnDate, createColumnInput, createColumnInputNumber } from "../../../../../components/table/c-table.logic";
import i18n from "../../../../../i18n";
import store from "../../../../../store";
import { createLoading } from "../../../../../utils/loading";
import { createConditionAction } from "../../../storage-location/request/request.condition";

export const { isLoading, setIsLoading } = createLoading();
const CIFrame = defineAsyncComponent(() => import("../../../../../components/iframe/CIFrame"));

export const actionPrefix = "resource/v1/transaction/storageLocation";
export const routerPrefix = 'haz-license-storage-locations'

export const callSave = ({ form }) => store.dispatch(`${actionPrefix}/save`, { data: form });
export const callSearch = ({ criteria }) => store.dispatch(`${actionPrefix}/search`, { criteria });
export const callActive = ({ id }) => store.dispatch(`${actionPrefix}/active`, { id });
export const callArchive = ({ id }) => store.dispatch(`${actionPrefix}/delete`, { id });
export const callDelete = ({ id }) => store.dispatch(`${actionPrefix}/delete`, { id, config: { params: { isHardDelete: true } } });
export const callActiveAll = ({ ids }) => store.dispatch(`${actionPrefix}/activeAll`, { ids });
export const callArchiveAll = ({ ids }) => store.dispatch(`${actionPrefix}/deleteAll`, { ids });
export const callDeleteAll = ({ ids }) => store.dispatch(`${actionPrefix}/deleteAll`, { ids, config: { params: { isHardDelete: true } } });
export const callChanges = ({ id, criteria }) => store.dispatch(`${actionPrefix}/changes`, { id, criteria });

export const onSearch = ({ page, state }) => {
    const where = page.where || [];
    const sort = page.sort || [];
    setIsLoading(true);
    window.onSearch?.({ page });
    return callSearch({ criteria: { ...page, data: [], where: [...where], sort } })
        .then(page => (state.page = { ...page, where, sort }))
        .finally(() => setIsLoading(false));
};

export const createColumns = ({ props }) => {
    const { isLocation } = props
    const columns = [
        createColumnInput({ title: () => i18n.global.t("model.storageLocation.name"), dataIndex: "name",  align: "center", visible: () => isLocation === true }),
        createColumnInput({ title: () => i18n.global.t("views.request.manufactureLocation.name"), dataIndex: "name",  align: "center", visible: () => isLocation === false }),
        createColumnInput({ title: () => i18n.global.t("model.address.modelName"), dataIndex: "addresses.0.addrTh",  align: "center" }),
        createColumnInput({ title: () => i18n.global.t("model.storageLocation.approveCode"), dataIndex: "approveCode", align: "center" }),
        createColumnDate({ title: () => i18n.global.t("model.storageLocation.expireDate"), dataIndex: "expireDate", align: "center" }),
        createColumnInputNumber({ title: () => i18n.global.t("model.storageLocation.productionArea"), dataIndex: "productionArea", align: "center", visible: () => isLocation === false, search: { visible: () => false } }),
        createColumnInput({
            title: () => i18n.global.t("model.storageLocationSub.totalCapacity"),
            visible: () => isLocation === true,
            dataIndexValue: ({ record }) => {
                let totalCapacity = 0
                record.subs.forEach(items => {
                    totalCapacity += items.totalCapacity
                })
                return  totalCapacity
            },
            customRender: ({ record, column }) => column.dataIndexValue({ record }),
            align: "center",
            sorter: false,
            search: { visible: () => false }
        }),
        createColumnInput({
            title: () => i18n.global.t("model.storageLocationSub.useCapacity"),
            visible: () => isLocation === true,
            dataIndexValue: ({ record }) => {
                let useCapacity = 0
                record.subs.forEach(items => {
                    useCapacity += items.useCapacity
                })
                return  useCapacity
            },
            customRender: ({ record, column }) => column.dataIndexValue({ record }),
            align: "center",
            sorter: false,
            search: { visible: () => false }
        }),
        createColumnInput({
            title: () => i18n.global.t("model.storageLocationSub.useKg"),
            visible: () => isLocation === true,
            dataIndexValue: ({ record }) => {
                let useKg = 0
                record.subs.forEach(items => {
                    useKg += items.useKg
                })
                return useKg
            },
            customRender: ({ record, column }) => column.dataIndexValue({ record }),
            align: "center",
            sorter: false,
            search: { visible: () => false }
        }),
    ]
    return columns
}

export const initState = ({ props }) => {
    const { menuContext, isLocation } = props;
    if (stateGroup[isLocation]) {
        return stateGroup[isLocation];
    }
    const state = {
        columns: createColumns({ props }),
        page: createPage({
            options: {
                select: ["**"],
                children: [
                    { name: "subs", select: ["**"], page: 0, size: 1000000, sort: [{ name: "createDate", type: "ASC" }] },
                    { name: "addresses", select: ["**"], page: 0, size: 1000000, sort: [{ name: "createDate", type: "ASC" }] }
                    ]
            }
        }),
        tableOptions: { search: { activeKey: "Search" } },
        conditionAction: createConditionAction()
    };
    state.manages = [
        createManageSelect({ menuContext }),
        createManageActive({
            menuContext,
            visible: () => !has({ menuContext, key: "canSelect", value: "true" }),
            onClick: ({ rowSelection }) =>
                onClickActiveAll({ rowSelection, callActiveAll, state, onSearch: search => onSearch({ props, ...search }), setIsLoading })
        }),
        createManageArchive({
            menuContext,
            visible: () => !has({ menuContext, key: "canSelect", value: "true" }),
            onClick: ({ rowSelection }) =>
                onClickArchiveAll({ rowSelection, callArchiveAll, state, onSearch: search => onSearch({ props, ...search }), setIsLoading })
        }),
        createManageDelete({
            menuContext,
            visible: () => !has({ menuContext, key: "canSelect", value: "true" }),
            onClick: ({ rowSelection }) =>
                onClickDeleteAll({ rowSelection, callDeleteAll, state, onSearch: search => onSearch({ props, ...search }), setIsLoading })
        }),
        createManageExportCsv({ menuContext })
    ];
    state.manageExtras = [
        createManageExtraCreate({ menuContext, onClick: () => onClickCreate({ routerPrefix }),
            visible: () => !has({ menuContext, key: "canSelect", value: "true" }) })
    ];
    if(!has({ menuContext, key: "canSelect", value: "true" }) ) {
        state.rowActions = [

            createRowActionView({ menuContext, onClick: ({ record }) => onClickView({ record, routerPrefix }) }),
            createRowActionEdit({
                menuContext,
                onClick: ({ record }) => onClickEdit({ record, routerPrefix }),
                visible: ({ record }) => state.conditionAction.canEdit({ props, record })
            })
        ];
    }
    return (stateGroup[isLocation] = state);
};

export const createFormTitle = ({ props }) => {
    const { isLocation } = props
    return isLocation ? i18n.global.t("views.request.storageLocation.title") : i18n.global.t("views.request.manufactureLocation.title")
};

export const openModalList = ({ bind, onIframeMounted }) => {
    const options = addModal({
        bind: lodash.merge(lodash.cloneDeep(modalStyleIFrame), bind),
        render: () => (
            <CIFrame
                src={`${process.env.VUE_APP_PUBLIC_PATH}/app/haz-license-storage-locations?isLayout=false&canSelect=true&cacheQuery=true`}
                onIframeMounted={({ refs }) => onIframeMounted({ options, refs })}
            ></CIFrame>
        )
    });
    return options;
};

export const openModalListMenufacture = ({ bind, onIframeMounted }) => {
    const options = addModal({
        bind: lodash.merge(lodash.cloneDeep(modalStyleIFrame), bind),
        render: () => (
            <CIFrame
                src={`${process.env.VUE_APP_PUBLIC_PATH}/app/haz-license-manufacture-locations?isLayout=false&canSelect=true&cacheQuery=true`}
                onIframeMounted={({ refs }) => onIframeMounted({ options, refs })}
            ></CIFrame>
        )
    });
    return options;
};

export const stateGroup = [];